export type ViewportShading = 'solid' | 'normals' | 'wireframe';

type ViewportShadingSelectProps = {
    viewportShading: ViewportShading;
    onViewportShadingChange: (viewportShading: ViewportShading) => void;
};

export const ViewportShadingSelect = ({ viewportShading, onViewportShadingChange }: ViewportShadingSelectProps) => {
    const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const val = e.target.value as ViewportShading;
        onViewportShadingChange(val);
    };
    
    return (
        <select name='viewport-shading' className="model-space-viewport-shading-select" value={viewportShading} onChange={handleSelectChange}>
            <option value='solid'>SOLID</option>
            <option value='normals'>NORMALS</option>
            <option value='wireframe'>WIREFRAME</option>
        </select>
    );
};